var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "_flex _gap-2 _ai-st _js-st _grow-1" }, [
    _vm.$slots.prefix
      ? _c("div", { staticClass: "_as-fs _shrink-0" }, [_vm._t("prefix")], 2)
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "_flexcol _grow-1 _tc--dark" },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm.$slots.suffix
      ? _c(
          "div",
          {
            staticClass: "_whs-nw _ml-4 _shrink-0 _flex _gap-2 _ai-c _tc--dark",
          },
          [_vm._t("suffix")],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }